<template>
  <div>
    <Modal v-model="isShow" :mask-closable="false" @on-ok="ok" :loading="loading"
           :class-name="z100000"
           @on-cancel="cancel"
           :width="650"
    >
      <h3 slot="header" class="modal-header">账单明细</h3>
      <Table :data="data" :columns="columns"></Table>
    </Modal>
  </div>


</template>
<script>
  import {getBalanceReceiptDetail} from "../../../api/settleManage";

  export default {
    name: ""   ,
    components:{
    },
    props:{
      n: {
        type: Number,
        default: 0
      },
      receiptNumber:{
        type:String,
        default:''
      },
      balanceFid: {
        type: String,
        default: ''
      },

    },
    watch:{
      n(){
        this.data=[]
        this.isShow=true
        this.getBalanceReceiptDetail()
      }
    },
    data(){
      return {
        loading: false,
        isShow:false,
        z100000:'z100000',
        data:[],
        columns:[
          {
            title:'应收帐单编号' ,
            key:'billNumber',
            align:'center'
          },

          {
            title:'费用项',
            key:'costCodeName',
            align:'center'
          },

          {
            title:'实收金额' ,
            key:'receiveMoney',
            align:'center'
          },
        ]

      }
    },
    methods:{
      getBalanceReceiptDetail(){
        if(!this.receiptNumber){
          return
        }
        getBalanceReceiptDetail({receiptNumber:this.receiptNumber,balanceFid:this.balanceFid}).then(res=>{
          res.data&& (this.data=res.data)
        }).catch(error=>{
        })
      },
      changeLoading() {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true
        })
      },
      ok(){

      },
      cancel(){

      }
    }

  }
</script>

<style scoped>

</style>
